import styled from 'styled-components'

export const StyledEmptyResult = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40vh;
  color: ${({ theme }) => theme.colors.textTertiary};
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
  flex: 1;

  p {
    width: 264px;
    text-align: center;
  }

  .title {
    margin-top: 12px;
    font-weight: 700;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
  }

  img {
    width: 88px;
    height: 88px;
  }
`
